import React from 'react';
import { I18n } from 'aws-amplify';
import { NavLink, Redirect } from "react-router-dom";

import constants from '../../../constants';

import { ClientProjectStatus } from '../../../model';

import { QueryString } from '../../../utils/querystring';

import FormatCurrency from '../../ui/format-currency';

export default class ClientProjectListFull extends React.Component {

    constructor(props) {
        super();

        var queryString = QueryString.extract(props.location.search);

        this.state = {
            q: '',
            status: queryString.status || '',
        };

        this.changeFilter = this.onChangeFilter.bind(this);
        this.select = this.onSelect.bind(this);
    }

    componentDidMount() {

        this.props.get_projects_full(this.state);
    }

    onChangeFilter(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            return Object.assign({}, prevState, {
                ...prevState,
                [prop]: value
            });
        }, function () {
            this.props.get_projects(this.state)
        });
    }

    onSelect(item, e) {
        this.setState({ selected: item.id });
    }

    getStatus(value) {
        if (!this.props.bp || !this.props.bp.clientProjectStatusesMap) return '';

        return this.props.bp.clientProjectStatusesMap[value] && this.props.bp.clientProjectStatusesMap[value].label;
    }

    render() {

        const currency = this.props.currency || {};

        if (this.state.selected) {
            return (<Redirect to={'/bpool/projetos/' + this.state.selected} />);
        }

        return (
            <div>

                <div className="field is-grouped table-mob">

                    <div className="control campo-table-mob">
                        <label className="label is-small">{I18n.get("Buscar")}</label>
                        <input onChange={this.changeFilter.bind(this, 'q')} className="input" type="text" placeholder={I18n.get("Nome")} />
                    </div>

                    <div className="control campo-table-mob">
                        <label className="label is-small">{I18n.get("Status")}</label>
                        <div className="select">
                            <select value={this.state.status} onChange={this.changeFilter.bind(this, 'status')}>
                                <option value="">{I18n.get("Todos status")}</option>
                                {this.props.bp.clientProjectStatuses && this.props.bp.clientProjectStatuses.map((item) => (<option key={item.code} value={item.code}>{item.label}</option>))}
                            </select>
                        </div>
                    </div>

                </div>

                <div className="">
                    <div className="table-main">

                        <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth hasTableCounter">
                            <thead>
                                <tr>
                                    <th>{I18n.get("Tipo")}</th>
                                    <th>{I18n.get("SKU")}</th>
                                    <th>{I18n.get("Criado")}</th>
                                    <th>{I18n.get("Nome")}</th>
                                    <th>R$</th>
                                    <th>{I18n.get("Cliente")}</th>
                                    <th>{I18n.get("Parceiro")}</th>
                                    <th>{I18n.get("Status")}</th>
                                    <th>{I18n.get("Selec")}</th>
                                    <th>{I18n.get("CHK")}</th>
                                    <th>{I18n.get("CHK Ent")}</th>
                                    <th>{I18n.get("CHK Atr")}</th>
                                    <th>{I18n.get("CHK últ")}</th>
                                    <th>{I18n.get("CHK próx")}</th>
                                    <th>SPA</th>
                                    <th>{I18n.get("SPA Data")}</th>
                                    <th>{I18n.get("Pgto")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.bp.projects && this.props.bp.projects.map((item, index) =>
                                    (<tr key={index}>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.projectType == 0 ? "C" : "E"}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.projectSKU}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.createdOn}
                                        </td>

                                        <td className="has-text-left">
                                            <NavLink to={`/bpool/projetos/${item.projectId}`} className="is-black">{item.projectName}</NavLink>
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            <FormatCurrency amount={item.total} currency={currency} />
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.clientCompanyName}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.partnerCompanyName}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.statusName}
                                        </td>

                                        <td onClick={this.select.bind(this, item)}>
                                            {item.partnerSelectedOn}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.checkpointsTotal}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.checkpointsDeliveredTotal}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.checkpointsRunningLate}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.lastCheckpoint}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.nextCheckpoint}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.po}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.poAddedOn}
                                        </td>
                                        <td onClick={this.select.bind(this, item)}>
                                            {item.paymentStimatedOn}
                                        </td>

                                    </tr>)
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        );
    }
}
